module.exports = __webpack_public_path__ + "static/media/empty-icon-message-fe.d5492fb3.svg";